// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import TrixController from "./trix_controller"
import AnnouncementModalController from "./announcement_modal_controller"

application.register("hello", HelloController)
application.register("trix", TrixController)

application.register("announcements-modal", AnnouncementModalController)
